// routes/ir/$cnpj/index.tsx — public Investor Relations page.
//
// URL contract:
//   /ir/<14-digit CNPJ>     — canonical, what gets shared / indexed.
//   /ir/<formatted CNPJ>    — accepted during the compat window;
//                              beforeLoad redirects to the digits form
//                              so a stale share/bookmark lands on the
//                              canonical URL. Mirrors the redirect the
//                              authed /companies/$cnpj route applies
//                              (see routes/_authenticated/companies/
//                              $cnpj/index.tsx).
//
// No `validateSearch`: the IR page has no filters. Year, type, etc. all
// live on the dashboard feed returned by /v2/companies-documents/search.

import { toDigitsCnpj } from "@shared/utils/cnpj";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { InvestorRelationsPage } from "@/features/investor-relations";

export const Route = createFileRoute("/ir/$cnpj/")({
  beforeLoad: ({ params }) => {
    const raw = params.cnpj;
    const clean = toDigitsCnpj(raw);
    // ponytail: only rewrite when we actually changed the URL — a digits-only
    // CNPJ passes through toDigitsCnpj unchanged, so the redirect is a no-op.
    // The formatted input lands here, gets normalised, and the address bar
    // updates via replace: true without bloating the back stack.
    if (clean && clean !== raw) {
      throw redirect({
        to: "/ir/$cnpj",
        params: { cnpj: clean },
        replace: true,
      });
    }
  },
  component: IrCnpjIndexRoute,
});

function IrCnpjIndexRoute() {
  const { cnpj: rawCnpj } = Route.useParams();
  const cnpj = decodeURIComponent(rawCnpj);
  return <InvestorRelationsPage cnpj={cnpj} />;
}
